import axios from 'axios'

export type BillingPlanStatus = 'invoice' | 'already_invoiced' | 'no_usage' | 'excluded' | 'error'

export interface TenantBillingStats {
  name: string
  bucketName: string
  invoiceDocuments: number
  workflowUsage: number
}

export interface InvoicePosition {
  product: string
  quantity: number
  description: string
  tenant?: string
}

export interface CustomerBillingPlan {
  customerNo: string
  customerName: string
  status: BillingPlanStatus
  tenants?: TenantBillingStats[]
  positions?: InvoicePosition[]
  error?: string
}

export interface BillingPreview {
  year: number
  month: string
  customers: CustomerBillingPlan[]
}

export const billingApi = {
  // Dry run: reports what the monthly billing would invoice, without creating anything.
  dryRun: (year: number, month: number, customerNo?: string) => {
    return axios.get<BillingPreview>('/api/billing/v1/dry-run', {
      params: { year, month, customerNo },
    })
  },
}
